import React from 'react';

import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import Image from '../../Image/Image.js';
import ISearchIconProps from '../models/ISearchIconProps.js';
import { SEARCH_CATEGORY_KEY, SEARCH_COMPONENT_KEY } from '../Search.meta.js';

// eslint-disable-next-line @typescript-eslint/naming-convention
const SelectedResultClear = (props: Partial<ISearchIconProps>) => {
	const { ...iconProps } = props;
	return <Image {...iconProps} />;
};

export default InjectedStyledComponent(SelectedResultClear, SEARCH_CATEGORY_KEY, SEARCH_COMPONENT_KEY, [
	'selectedResultClear',
]);
